import { useEffect, useRef, useState } from "react";
import type { IdleMediaItem } from "../lib/kiosk-client";

interface Props {
  items: IdleMediaItem[];
  loopIntervalSeconds: number;
}

export function IdleMedia({ items, loopIntervalSeconds }: Props) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const timer = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (items.length === 0) return;
    timer.current = setInterval(() => {
      setCurrentIndex((i) => (i + 1) % items.length);
    }, loopIntervalSeconds * 1000);
    return () => {
      if (timer.current) clearInterval(timer.current);
    };
  }, [items, loopIntervalSeconds]);

  if (items.length === 0) {
    return (
      <div
        className="absolute inset-0 bg-[var(--kiosk-brand-primary)]"
        aria-hidden="true"
      />
    );
  }

  const item = items[currentIndex];
  if (!item) return null;

  const isVideo = item.content_type.startsWith("video/");

  return (
    <div className="absolute inset-0 overflow-hidden" aria-hidden="true">
      {isVideo ? (
        <video
          key={item.url}
          src={item.url}
          className="w-full h-full object-cover"
          autoPlay
          muted
          loop
          playsInline
        />
      ) : (
        <img
          key={item.url}
          src={item.url}
          alt=""
          className="w-full h-full object-cover"
          draggable={false}
        />
      )}
    </div>
  );
}
